import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["align", "children", "size", "component"];
import React from 'react';
import { useDeprecatedClassNameStylePropsWarning } from '../../internal/deprecated-classname-style-props';
import { Type } from '../Type/Type';
import { useTitleStyles } from './useTitleStyles';

/**
 * The Title component is intended for top-level information on a page. The variants offer Chronicle in two sizes – `default` and `small`.
 *
 * - Title (default) appears globally as the `h1` style for every page. Limit usage to one per page.
 * - Title (`small`) signals a change in topic/section within the content of a page. Use intentionally for section titles only.
 * - Limit line-width to 8 columns per Level AA WCAG guidelines
 * - This component resizes for mobile web automatically
 */
export var Title =
/*#__PURE__*/

/**
 * Title abstraction over Type. We spread the constrained Title
 * props last and explicitly set others to undefined to prevent them from
 * being overridden.
 *
 * For example, titles should not be a different color.
 */
React.forwardRef(function (_ref, ref) {
  var align = _ref.align,
      children = _ref.children,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'default' : _ref$size,
      component = _ref.component,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  useDeprecatedClassNameStylePropsWarning('Title', {
    className: otherProps.className,
    style: otherProps.style
  });
  return /*#__PURE__*/React.createElement(Type, _extends({}, useTitleStyles({
    size: size
  }), otherProps, {
    align: align,
    fontFamily: "chronicle",
    color: undefined,
    component: component,
    "data-currency": "Title",
    ref: ref,
    size: size === 'default' ? 5 : 4
  }), children);
});
Title.displayName = 'Title';